import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, retry } from 'rxjs';
import { Constants } from '../constant';
import { Common } from '../../shared/common';
import { Campus } from '../models/campus';

@Injectable()
export class CampusService {

  constructor(private http: HttpClient) {}

  /**
   * Returns all active campuses from campus_master.
   * Wraps the existing CampusController GET /campus/all endpoint.
   */
  getAllCampuses(): Observable<Campus[]> {
    return this.http.get<any>(Constants.getApiEndpoint() + '/campus/all')
      .pipe(
        map((res: any) => res.result || []),
        retry(1),
        catchError(Common.handleError)
      );
  }
}
